import { render, staticRenderFns } from "./OptionLabel.vue?vue&type=template&id=12be050d&scoped=true&"
import script from "./OptionLabel.vue?vue&type=script&lang=js&"
export * from "./OptionLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be050d",
  null
  
)

export default component.exports